import { useEffect, useMemo, useRef } from 'react';
import '../../apis/base';
import './marquee.scss';

export default function Marquee(props) {
  // 字体循环滚动需要设置定时器，存储定时器id变量
  const startScroll = useRef(null);
  // 滚动容器，滚动计算时需要读取容器大小
  const tmpScrollobj = useRef(null);
  // 滚动文案，滚动计算时需要读取文案大小
  const tmpScrollText = useRef(null);
  // 父组件传递的展示文案信息
  // 无缝滚动时，文案会无限拼接,可能导致文案展示很长,在不需要滚动时将文案还原
  const showTextRef = useRef(null);

  function scroll() {
    // 保证下方的计算时有对应的元素
    if (!tmpScrollobj.current || !tmpScrollText.current) return;
    //　当滚动条滚动了初始内容的宽度时滚动条回到最左端
    if (tmpScrollText.current.offsetWidth <= tmpScrollobj.current.offsetWidth) {
      tmpScrollobj.current.scrollLeft = 0;
    } else {
      // 往左
      // eslint-disable-next-line
      const tmp = tmpScrollobj.current.scrollLeft++;
      //　当滚动条到达右边顶端时
      if (tmpScrollobj.current.scrollLeft === tmp) {
        if (window.navigator.userAgent) {
          const tempArray = navigator.userAgent.toLowerCase().match(/chrome\/([\d.]+)/);
          // if (!tempArray) return;
          if (tempArray && tempArray[1] && tempArray[1].substring(0, 2) === '53') {
            tmpScrollText.current.innerHTML += `&nbsp; ${tmpScrollText.current.innerHTML}`;
          } else {
            tmpScrollText.current.innerHTML += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${tmpScrollText.current.innerHTML}`;
          }
        } else {
          tmpScrollText.current.innerHTML += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${tmpScrollText.current.innerHTML}`;
        }
      }
    }
    // 往上
    // const tmp = (obj.scrollTop)++;
    // if (obj.scrollTop == tmp) {
    // obj.innerHTML += obj.innerHTML;
    // }
    // if (obj.scrollTop >= obj.firstChild.offsetWidth) {
    // obj.scrollTop = 0;
    // }
  }
  // 滚动方法
  function start() {
    startScroll.current = setInterval(() => {
      scroll();
    }, 15);
  }

  function clearTimer() {
    startScroll.current && clearInterval(startScroll.current);
    startScroll.current = null;
  }

  function resetValue() {
    // 将盒子滚动位置置为0
    tmpScrollobj.current && (tmpScrollobj.current.scrollLeft = 0);
    // 将盒子文案展示为最初的文案
    tmpScrollText.current && (tmpScrollText.current.innerHTML = showTextRef.current);
  }

  useEffect(() => {
    // 保存父元素所传递文案数据
    showTextRef.current = props.children;
  }, [props.children]);

  useEffect(() => {
    // scrollStatus 滚动状态，是否滚动
    // scrollStatus为true时，滚动，false时，取消滚动并清除定时器，并重置相应的状态
    const { scrollStatus } = props;
    if (!scrollStatus) {
      clearTimer();
      resetValue();
    } else {
      start();
    }
  }, [props.scrollStatus]);

  useEffect(() => () => clearTimer(), []);

  // 父元素所传的展示文案
  const children = useMemo(() => props.children || null, [props.children]);
  // 父元素所传的宽度
  // 如果mainWidth没有传递，则宽度和父元素宽度保持一致
  const mainWidth = useMemo(() => props.mainWidth || null, [props.mainWidth]);

  return (
    <div
      className='scrollobj'
      ref={tmpScrollobj}
      style={{ width: mainWidth ? `${mainWidth / global.constants.rootValue}rem` : '100%' }}
    >
      <span className='scrollText' ref={tmpScrollText}>
        {children}
      </span>
    </div>
  );
}
